// src/pages/NotFound.jsx

import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 text-center px-6">
      {/* Big 404 Number */}
      <h1 className="text-[8rem] font-extrabold text-blue-600 drop-shadow-md">
        404
      </h1>

      {/* Title */}
      <h2 className="text-3xl font-bold text-gray-800 mt-2">
        Oops! Page Not Found
      </h2>

      {/* Back to Home Button */}
      <Link
        to="/"
        className="mt-8 px-8 py-3 bg-blue-600 text-white text-lg font-medium rounded-full shadow-lg hover:shadow-xl hover:bg-blue-700 transition-all duration-300 ease-in-out backtohome"
      >
        ⬅ Back to Home
      </Link>

   
    </div>
  );
};

export default NotFound;
